// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageWithOverlay_wrapper__3i7HH","overlay":"ImageWithOverlay_overlay__1i-EE"};